import React, { Component } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { bindActionCreators } from 'redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'
import mixpanel from '@disco/api/mixpanel'
import { updateUserSettingsUnsafe } from '@disco/state-management/actions/ExplorerActions'
import { deletePlaylist } from '@disco/state-management/actions/ServerActions'
import { getExplorerFirstPaneGroupId } from '@disco/state-management/selectors/explorer'
import { getPlaylist } from '@disco/state-management/selectors/playlists'
import { getHideInboxRemovalSetting } from '@disco/state-management/selectors/user'
import DocumentHeadTags from 'components/document-head-tags'
import InboxRemovalDialog from 'components/modals/dialogs/inbox-removal-dialog'
type Playlist = {
  playlist_id: number
}

function mapStateToProps(state, { params: { playlistId } }) {
  return {
    playlist: getPlaylist(state, {
      id: playlistId,
    }),
    groupId: getExplorerFirstPaneGroupId(state),
    hideRemovalWarning: getHideInboxRemovalSetting(state),
    settings: state.user.settings,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      deletePlaylist,
      updateUserSettingsUnsafe,
    },
    dispatch,
  )
}

// Define connector
const connector = connect(mapStateToProps, mapDispatchToProps)

// Infer props type from Redux
type PropsFromRedux = ConnectedProps<typeof connector>

// Own props interface
interface OwnProps {
  navigate: NavigateFunction
  params: {
    playlistId: string
  }
}

// Component props = Redux props + own props
type Props = PropsFromRedux & OwnProps

class InboxPlaylistRemove extends Component<Props> {
  _onClose = () => this.props.navigate('/')
  _handleDelete = () => {
    this.props.deletePlaylist(this.props.playlist)
    mixpanel.sendPureEvent('Click icon', {
      'Playlist ID': this.props.playlist?.playlist_id,
      Type: 'Playlist',
      Icon: 'Delete',
      Context: 'Inbox',
    })
    this.props.navigate('/')
  }
  _hideWarning = () => {
    this.props.updateUserSettingsUnsafe({
      settings: {
        hide_inbox_removal_warning: !this.props.hideRemovalWarning,
      },
    })
  }

  render() {
    return (
      <div>
        <DocumentHeadTags title="Remove playlist from inbox | DISCO" />
        <InboxRemovalDialog
          onConfirm={this._handleDelete}
          onCancel={this._onClose}
          onHideWarningChange={this._hideWarning}
          hideWarning={Boolean(this.props.hideRemovalWarning)}
          type="playlist"
        />
      </div>
    )
  }
}

const ConnectedInboxPlaylistRemove = connector(InboxPlaylistRemove)

function InboxPlaylistRemoveWithRouter(props: any) {
  const navigate = useNavigate()
  const params = useParams<{ playlistId: string }>()
  return (
    <ConnectedInboxPlaylistRemove
      {...props}
      navigate={navigate}
      params={params}
    />
  )
}

export default InboxPlaylistRemoveWithRouter
